import React, { memo, useCallback } from 'react'

import { array } from 'prop-types'

import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { toggleAdvancedSettingsExpanded } from 'Pods/ThreeDStudio/Store/actions/ui'

import AdvancedSettingsContent from './Components/AdvancedSettingsContent/AdvancedSettingsContent'
import AdvancedSettingsTrigger from './Components/AdvancedSettingsTrigger/AdvancedSettingsTrigger'

function AdvancedSettings({ items }) {
  const isExpanded = useThreeDStudioStore(state => state.ui.isAdvancedSettingsExpanded)

  const handleTriggerClick = useCallback(() => {
    trackSettingsInteraction('advanced_settings', isExpanded ? 'collapsed' : 'expanded')
    toggleAdvancedSettingsExpanded()
  }, [isExpanded])

  return (
    <div className="advanced-settings">
      <AdvancedSettingsTrigger isExpanded={isExpanded} onClick={handleTriggerClick} />
      {isExpanded && (
        <AdvancedSettingsContent items={items} />
      )}
    </div>
  )
}

AdvancedSettings.propTypes = {
  items: array.isRequired,
}

export default memo(AdvancedSettings)
